import { DatePipe } from '@angular/common';
import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AdminService, AdminStats } from '../../../core/admin/admin';
import { PersonModal } from '../person-modal/person-modal';

@Component({
  selector: 'app-admin-dashboard',
  imports: [DatePipe, RouterLink, PersonModal],
  templateUrl: './admin-dashboard.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './admin-dashboard.css',
})
export class AdminDashboard implements OnInit {
  private readonly adminService = inject(AdminService);

  readonly loading = signal(true);
  readonly errorMessage = signal<string | null>(null);
  readonly stats = signal<AdminStats | null>(null);

  /** F-009 Milestone B — clicking a name in either recent list opens this. */
  readonly openPersonId = signal<number | null>(null);

  async ngOnInit(): Promise<void> {
    await this.load();
  }

  onModalClosed(): void {
    this.openPersonId.set(null);
  }

  async onModalChanged(): Promise<void> {
    await this.load();
  }

  private async load(): Promise<void> {
    this.loading.set(true);
    this.errorMessage.set(null);
    try {
      this.stats.set(await this.adminService.getStats());
    } catch {
      this.errorMessage.set('Could not load admin stats — try again in a moment.');
    } finally {
      this.loading.set(false);
    }
  }
}
